// extracted by mini-css-extract-plugin
export default {"footerArea":"Footers_footerArea__7BV0v"};